<template>
	<a href="#" @click.prevent="invokeAction" class="cell-click"></a>
</template>

<script setup lang="ts">
import type {DataColumn} from "@t/fd/layout/Agenda.ts";
import {injectCellAPI, rowObjectKey} from "@fd/containers/agenda/AgendaUtils.ts";
import {inject} from "vue";

const props = defineProps<{
	/** Name of an action to be invoked on CellAPI */
	action: string;
	/** Object with data for the row */
	object: object;
	/** Column specs */
	col: DataColumn;
}>();
defineOptions({ name: 'cell-click' });

const api = injectCellAPI();
const rowKey = inject(rowObjectKey, null);

function invokeAction(e:MouseEvent) {
	api.action(props.action, rowKey, e);
}
</script>

<style>
.cell-click {
	user-select: none;
	-webkit-user-select: none;
}
</style>